<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="specific-commerce">
      <Title jpn="特定商业交易法" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">运营公司名称</span>
            <span class="text">哈奇有限公司</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">代表人</span>
            <span class="text">八冢 健</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">公司注册地址/营业办公地址</span>
            <span class="text">邮编：547-0011</span>
            <span class="text">大阪府大阪市平野区長吉出戸七丁目3-39</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">电话号码</span>
            <span class="text">06-6643-9996</span>
            <span class="text">(*接待时间：平日 10:00-17:00)</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">电子邮件</span>
            <span class="text">支持@xeroplace.jp</span>
            <span class="text">*如有疑问，请使用网站上的聊天室。原则上我们会在2个工作日内回复。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">价格</span>
            <span class="text">显示每个产品</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
        class="shadow-box-title-description"
        title=""
        >
        <div class="text-container left">
            <span class="text">产品价格以外的必要费用</span>
            <span class="text">使用本公司提供的服务的设备相关费用、网络连接费、数据包通信费、消费税、支付转帐费。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">交货时间</span>
            <span class="text">受理申请时</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">销售数量</span>
            <span class="text">没有具体的规格。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">付款方式</span>
            <span class="text">我们接受信用卡、PayPal 和 Amazon Pay。</span>
            <span class="text">*付款后，我们不接受因客户方便而取消订单。感谢您的理解。</span>
            <span class="text">若逾期未付款，则自动取消。</span>
            <span class="text">付款期限</span>
            <span class="text">信用卡：基于信用卡公司的条款和条件。</span>
            <span class="text">PayPal：基于 PayPal 条款。</span>
            <span class="text">Amazonpay：基于 Amazonpay 条款和条件。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">退货政策和期限</span>
            <span class="text">一般来说，我们不接受退货或换货，但如果我们有 100% 的过错，我们会做出回应。</span>
            <span class="text">但是，以下情况我们无法应对。感谢您的理解。</span>
            <span class="text">如果物品在运送过程中丢失或损坏</span>
            <span class="text">如果未开封的物品如BOX等没有视频记录。</span>
            <span class="text">*我们在检查再收缩产品时要特别小心。</span>
            <span class="text">如果产品到达后已超过 10 天</span>
            <span class="text">如果您发现PSA等鉴定品有划痕等，并以此为理由接受您的换货或退货请求。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container left">
            <span class="text">古董商营业执照</span>
            <span class="text">没有431370066203</span>
            <span class="text">零地有限公司</span>
            <span class="text">埼玉县公安委员会</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n';

export default {
  name: 'SpecificCommerce',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),

  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.specific-commerce{
  width: 100%;
  max-width: 1000px;
  padding: 30px 20px 0;
  margin: 0 auto;
  .specific-commerce-title{
    display: flex;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          a {
            color: blue!important;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
          &.none{
            color: red;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
table.code {
  width: 100%;
  th, td {
    font-size: 16px;
    color: $white;
  }
  th {
    font-weight: normal;
    text-align: left;
    padding-right: 10px;
    width: 200px;
  }
  td {
    text-align: left;
    padding-left: 10px;
  }
}
@media screen and  (max-width: $tabletWidth) {
  .specific-commerce{
    .scroll-container{
      .shadow-box-title-description{
        .text-container{
          .text{
            font-size: 14px;
          }
        }
      }
    }
  }
  table.code {
    width: 100%;
    th, td {
      display: block;
      font-size: 14px;
    }
    th {
      text-align: left;
      padding-right: 0;
      &:after {
        content: '';
      }
    }
    td {
      text-align: left;
      padding-left: 0;
      padding-bottom: 10px;
    }
  }
  .left {
    text-align: left!important;
  }
}
</style>
